<template>
  <div data-lenis-prevent class="fixed top-0 left-0 w-full h-full flex items-start justify-center z-50 backdrop-blur-sm">
    <div class="fixed top-0 left-0 w-full h-full z-0" @click="close"/>
    <div class="max-w-[1024px] mx-auto w-full h-full overflow-auto md:p-6 md:py-20 no-scrollbar relative z-10">
      <div class="bg-ellie-blue p-6 md:py-16 md:rounded-xl text-white relative shadow-xl">
        <button class="absolute right-3 top-3" @click="close">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
        <div class="max-w-screen-md mx-auto">
          <div class="space-y-3 mb-6">
            <h1 class="text-left whitespace-pre-line font-medium text-2xl md:text-[4.167vw] big-screen:text-[3.1vw] leading-[1.1] text-ellie-yellow">
              Have an Idea?
            </h1>
            <p class="text-left text-ellie-yellow font-medium text-sm md:text-[1.111vw] big-screen:text-[1vw] leading-[1.5]">Let’s connect and have a chat to see how we could help you.</p>
          </div>
          <div class="space-y-6">
            <UIFormInputText id="name" label="Name" required class="relative text-gray-700" />
            <div class="grid grid-cols-2 gap-6">
              <UIFormInputText id="phone" label="Phone Number" required class="relative text-gray-700" />
              <UIFormInputEmail id="email" label="Email Address" required class="relative text-gray-700" />
            </div>
            <UIFormInputTextArea id="message" label="Message" required class="relative text-gray-700" />
            <UIFormSelect
              id="timeline" label="Timeline"  class="relative text-gray-700"
              :options="[
                { label: 'Less than 2 weeks', value: 'Less than 2 weeks' },
                { label: '3 - 4 weeks', value: '3 - 4 weeks' },
                { label: '> 4 weeks', value: '> 4 weeks ' }
              ]" />
            <UIFormSelect
id="budget" label="Budget" class="relative text-gray-700"
              :options="[
              { label: '10k - 20k', value: '10k - 20k' },
              { label: '20k - 50k', value: '20k - 50k' },
              ]"
              help-text="Please select one of the following (if any)"
            />

            <div class="border border-white/20 p-3 rounded-md">
              <button class="flex gap-1 text-white text-sm items-center" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                Attachment
              </button>
            </div>

            <button class="uppercase text-ellie-black bg-ellie-yellow rounded-full hover:bg-black border hover:border-ellie-yellow hover:text-ellie-yellow transition-all duration-300 leading-[0] w-fit block text-sm px-8 py-5 md:px-[1.5vw] md:py-[1.4vw] text-[1.3w] big-screen:text-[1vw] tracking-[0.01vw] font-medium" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">Send Message</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['close'])

const close = () => {
  emits('close')
}
</script>

<style lang="scss" scoped>

</style>